import { BOGO_QUANTITY_INCREMENT } from '@/features/shared/constants/global'
import {
  type PromotionMetadata,
  type Product,
  type ProductCampaignsPromotion,
} from '@/features/shop/services/Product/types'
import { getProductDetails } from '@/features/shared/utils/getProductDetails'
import { formatPrice } from '@/features/shared/utils/formatter'
import { type ProductCardProduct } from '@/features/shop/components/ProductCard/types'

export const getPromotionName = (
  promotion?: ProductCampaignsPromotion | null,
  bogo?: boolean,
  isPromotionCompleted?: boolean,
  promotionMetadata?: PromotionMetadata | null,
) => {
  if (promotionMetadata?.callout_text) {
    return promotionMetadata.callout_text
  }

  if (isPromotionCompleted) {
    return 'Savings applied'
  }

  if (promotion?.category_id && bogo) {
    return 'Multiple Promos'
  }
  if (bogo) {
    return 'Buy 1, Get 1 Free'
  }
  if (promotion?.category_id) {
    return promotion.category_name
  }
  return ''
}

type QtyIncrementProduct = Pick<Product, 'bogo' | 'type' | 'hasCustomLabel' | 'unitWeight'>

export const getQtyIncrementForProduct = (product: QtyIncrementProduct) => {
  const { bogo, type, hasCustomLabel, unitWeight } = product
  if (type === 'by weight' && !hasCustomLabel) {
    return bogo ? BOGO_QUANTITY_INCREMENT * unitWeight : unitWeight
  } else {
    return bogo ? BOGO_QUANTITY_INCREMENT : 1
  }
}

export const getProductCardAriaLabel = (product: ProductCardProduct, rewardItemPrice?: number) => {
  const { bogo, totalSalePrice, promotionSubtotal } = product
  const { subtext, formattedPrice, formattedSalePrice } = getProductDetails(product)
  const name = getProductCardName(product)
  const currentPrice = rewardItemPrice ?? promotionSubtotal

  let priceText = formattedPrice
  if (currentPrice !== undefined) {
    priceText = `${formattedPrice}, Current price ${formatPrice(currentPrice)}`
  } else if (totalSalePrice) {
    priceText = `${formattedPrice}, On sale for ${formattedSalePrice}`
  }
  const bogoText = bogo ? ', Buy 1, Get 1' : ''

  return `${name}, ${subtext}, ${priceText}${bogoText}`.trim()
}

export const getProductCardName = (
  product: Pick<ProductCardProduct, 'variationDisplayName' | 'parent' | 'name'>,
): string => {
  const { variationDisplayName, parent, name } = product

  const isVariationProduct = Boolean(parent)

  return (isVariationProduct && variationDisplayName) || name
}
